import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["component", "children", "shouldRenderSearch", "shouldRenderTabs", "shouldRenderCompactSearchBar", "shouldRenderFullScreen", "shouldRenderCenteredContent", "pageTitleI18nKey"];
import { Route } from 'quartz-routing/react-router';
import { NavPage } from './NavPage';
import { usePageTitle } from '../../../hooks/usePageTitle';
import { jsx as _jsx } from "react/jsx-runtime";
const NavPageRouteInner = ({
  routeProps,
  navPageProps,
  component: Component,
  children,
  pageTitleI18nKey
}) => {
  usePageTitle({
    i18nKey: pageTitleI18nKey,
    isRouteTitle: true
  });
  if (Component) {
    return /*#__PURE__*/_jsx(NavPage, Object.assign({}, navPageProps, {
      children: /*#__PURE__*/_jsx(Component, Object.assign({}, routeProps))
    }));
  }
  return /*#__PURE__*/_jsx(NavPage, Object.assign({}, navPageProps, {
    children: children
  }));
};
export const NavPageRoute = _ref => {
  let {
      component,
      children,
      shouldRenderSearch,
      shouldRenderTabs,
      shouldRenderCompactSearchBar,
      shouldRenderFullScreen,
      shouldRenderCenteredContent,
      pageTitleI18nKey
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const navPageProps = {
    shouldRenderSearch,
    shouldRenderTabs,
    shouldRenderCompactSearchBar,
    shouldRenderFullScreen,
    shouldRenderCenteredContent
  };
  return /*#__PURE__*/_jsx(Route, Object.assign({}, rest, {
    render: props => /*#__PURE__*/_jsx(NavPageRouteInner, {
      component: component,
      navPageProps: navPageProps,
      pageTitleI18nKey: pageTitleI18nKey,
      routeProps: props,
      children: children
    })
  }));
};